import { getM3U } from 'API/v1/GetM3U';
import { parseM3UtoJSON } from './parseM3UtoJSON';

export async function getM3UList(publicPath) {
    if (!publicPath) {
        return [];
    }
    return parseM3UtoJSON(await getM3U(publicPath));
}